import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';
import { brandPrimary } from '../../../../styles/colors';
import { CssSelectors } from '../../../../styles/styles';

const { spacing, colors, typography } = THEME;

export const styleSheet = StyleSheet.create({
	tabRoot: {
		paddingLeft: spacing.md,
	},
	tabs: {
		boxSizing: 'border-box',
		display: `flex`,
		width: '100%',
		alignItems: 'center',
		justifyContent: 'flex-start',
		height: 60,
		borderBottom: THEME.common.border,
		background: THEME.colors.background.light,
		gap: THEME.spacing.xl,
		position: 'sticky',
		top: 0,
		zIndex: 3,
	},
	tabTrigger: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: spacing.sm,
		textDecoration: 'none',
		fontSize: `0.875rem`,
		color: colors.text.light,
		fontWeight: 500,
		height: '100%',
		':is([data-state="active"])': {
			color: colors.primary.main,
			borderBottom: `3px solid ${brandPrimary}`,
		},
	},
	tabTriggerFile: {
		':is([data-state="active"])': {
			...CssSelectors.allDescendants({
				fill: 'white',
			}),
		},
	},
	contactActivity: {
		height: `100%`,
	},
	contactActivityTabviewTabbarItemIcon: {
		display: 'inline-block',

		'@container contactActivity (min-width: 400px)': {
			display: 'none',
		},

		'@container contactActivity (min-width: 600px)': {
			display: 'inline-block',
		},
	},
	contactActivityTabviewTabbarItemTitle: {
		display: 'none',
		textAlign: 'center',

		'@container contactActivity (min-width: 400px)': {
			display: 'inline-block',
		},
	},
	dropdown: {
		width: 250,
	},
	richContentFilterOptionsContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		margin: '0 30 0 auto',
		padding: '15px 0',
		zIndex: 1,
		...CssSelectors.allChildren({
			borderRadius: 30,
		}),
	},
	timelineFilterOptionsContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		paddingTop: 15,
		gap: spacing.md,
		alignItems: 'center',
	},
	expandToggleLabel: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.xs,
		fontSize: typography.fontSizes.sm,
		color: colors.text.main,
		cursor: 'pointer',
		userSelect: 'none',
	},
	expandToggleCheckbox: {
		accentColor: colors.primary.main,
		cursor: 'pointer',
	},
});
